import { Directive, Renderer2, ElementRef, HostListener, Input, AfterViewInit, EventEmitter, Output } from '@angular/core';
declare var $: any;
@Directive({
    selector: '[onReturn]'
})
export class OnReturnDirective {
    private el: ElementRef;
    value: String = '';
    @Input() onReturn: String;
    constructor(private _el: ElementRef) {
        this.el = this._el;
    }
    @HostListener('keydown', ['$event']) onKeyUp(e) {
        // console.log(e)
        if (e.keyCode === 13) {
            e.preventDefault();
            if (e.srcElement.nextElementSibling) {
                e.srcElement.nextElementSibling.focus();
            } else {
                console.log('close keyboard');
            }
            return;
        }

    }
}


@Directive({
    selector: '[maskPass]'
})
export class OnMaskInputDirective implements AfterViewInit {
    private el: ElementRef;
    value: String = '';
    type = '';
    private isRecreating = false;
    @Input() visible: String;
    @Input() dateOuCouleure: Boolean;
    constructor(private _el: ElementRef, private renderer: Renderer2) {
        this.el = this._el;
        this.type = this.el.nativeElement.type;
    }

    ngAfterViewInit() {
        const _chrome = navigator.userAgent.indexOf('Chrome') > -1;
        if (_chrome) {
            setTimeout(() => {
                const randomString = Math.random().toString(36).slice(-6);
                this.renderer.setAttribute(this.el.nativeElement, 'name', randomString);
                this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', 'garbage');
            });
        } else {
            setTimeout(() => {
                this._el.nativeElement.setAttribute('autocomplete', 'off');
            });
        }
        if (!this.visible) {
            this.el.nativeElement.type = `password`;
        } else {
            this.el.nativeElement.type = this.type;
        }
    }

    @HostListener('focus', ['$event']) onFocus(e: FocusEvent) {
        const input = this.el.nativeElement as HTMLInputElement;

        // (si tu dois changer le type)
        input.type = this.type;

        // Sélectionner tout au focus
        if (input.type !== 'number') {
            requestAnimationFrame(() => {
                if ( document.activeElement === input) {
                    input.setSelectionRange(0, input.value.length);
                }
            });
        }
    }

    @HostListener('keydown', ['$event']) onKeyDown(e) {
        this.el.nativeElement.type = this.type;
    }

    @HostListener("ngModelChange", ["$event"]) onNgModelChange(value) {
        if (this.dateOuCouleure) {
            console.log(value)
            this.el.nativeElement.type = this.type;
        }
    }
}


@Directive({
    selector: 'input[type=number], [numeric], [focusAll]'
})
export class OnlyNumberDirective implements AfterViewInit {
    isFocus = false;
    isFocusEvent = false;
    private specialKeys = [
        'Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'
    ];

    @Input('decimals') decimals = 5;
    @Input('ngModel') ngModel;
    @Output('change') change = new EventEmitter<any>();
    @Input('disableArrowValue') disableArrowValue = false;

    @HostListener('wheel', ['$event'])
    onWheel(event: Event) {
        event.preventDefault();
    }

    @HostListener('focus', ['$event'])
    onFocus(event: KeyboardEvent) {
        this.isFocusEvent = true;
        const ctrl = this;
        this.isFocus = true;
        const focus = $(ctrl.el.nativeElement);
        focus.select();

        event.preventDefault();
        event.stopPropagation();
        console.log('isfocusEvent Event')
    }

    @HostListener('click', ['$event'])
    onClick(event: KeyboardEvent) {
        if (!this.isFocusEvent) {
            this.isFocus = !this.isFocus;
            console.log('isclick Event')
        } else {
            this.isFocusEvent = false;
        }
    }

    private check(value: string, decimals) {
        if (decimals <= 0) {
            return String(value).match(new RegExp(/^\d+$/));
        } else {
            // const regExpString = '^\\s*((\\d+(\\.\\d{0,' + decimals + '})?)|((\\d*(\\.\\d{1,' + decimals + '}))))\\s*$';
            // const regExpString = '^\\s*((\\d+([\\.,\\,]\\d{0,' + decimals + '})?)|((\\d*(\\[\\.,\\,]\\d{1,' + decimals + '}))))\\s*$';
            const regExpString = '^((-?(\\d+([\\.,\\,]\\d{0,' + decimals + '})?))|(-?((\\d*(\\[\\.,\\,]\\d{1,' + decimals + '})))))$';
            return String(value).match(new RegExp(regExpString));
        }
    }



    @HostListener('keyup', ['$event'])
    onKeyUp(event: KeyboardEvent) {

        if (this.specialKeys.indexOf(event.key) !== -1) {
            this.isFocus = false;
            return;
        }

        if (this.disableArrowValue) {
            if (event['which'] === 38 || event['which'] === 40) {
                this.el.nativeElement.disable = true;
                this.isFocus = false;
                event.preventDefault();
                setTimeout(() => {
                    this.el.nativeElement.disable = false;
                }, 200)
                return;
            }
        }

        // Do not use event.keycode this is deprecated.
        // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
        console.log('keyup   this.isFocus =' + this.isFocus);
        const current: string = this.el.nativeElement.value;
        const next: string = current.concat(event.key);
        if (next && next !== '' && this.isFocus) {
            console.log(next)

            this.isFocus = false;
            return;
        }
        this.remetreUn0();
        if (next && next !== '' && event.key === '-') {
            this.isFocus = false;
            if (this.el.nativeElement.value) {
                event.preventDefault();
                this.el.nativeElement.value = Math.abs(parseFloat(this.el.nativeElement.value)) * -1;
                const changefct = new Event('change');
                this.el.nativeElement.dispatchEvent(changefct);
            }
            return;
        }

    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (this.specialKeys.indexOf(event.key) !== -1) {
            this.isFocus = false;
            return;
        }

        if (this.disableArrowValue) {
            if (event['which'] === 38 || event['which'] === 40) {
                this.isFocus = false;
                event.preventDefault();
                setTimeout(() => {
                    this.el.nativeElement.disable = false;
                }, 200)
                return;
            }
        }
        // Do not use event.keycode this is deprecated.
        // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
        const current: string = this.isFocus ? '' : this.el.nativeElement.value;
        const next: string = current.concat(event.key);

        if (next && next !== '-' && next !== '.' && next !== ',' && !this.check(next, this.decimals)) {
            // this.isFocus = false;
            if (!this.isFocus) {
                event.preventDefault();
            }
        }
    }

    constructor(private el: ElementRef, private renderer: Renderer2) {
        if (this.el.nativeElement && this.el.nativeElement.type === 'text') {
            this.el.nativeElement.type = 'number';
        }

    }

    ngAfterViewInit() {
    }

    remetreUn0() {
        const ctrl = this;
        const delay = setTimeout(function () {
            const value = '' + ($(ctrl.el.nativeElement).val());
            if ((value || '').startsWith(',') || (value || '').startsWith('.')) {
                $(ctrl.el.nativeElement).val('0' + value);
            }
            clearTimeout(delay);
        }, 10);
    }

}


@Directive({
    selector: '[focusAlls]'
})
export class SelectValueDirective {
    isFocus = false;
    constructor(private el: ElementRef, private renderer: Renderer2) {
    }


}

@Directive({
    selector: 'input[type=text], input[type=email]'
})
export class DisableAutoCompleteDirective implements AfterViewInit {
    isFocus = false;
    constructor(private el: ElementRef, private renderer: Renderer2) {
    }

    ngAfterViewInit() {
        const _chrome = navigator.userAgent.indexOf('Chrome') > -1;
        if (_chrome) {
            setTimeout(() => {
                const randomString = Math.random().toString(36).slice(-6);
                this.renderer.setAttribute(this.el.nativeElement, 'name', randomString);
                this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', 'garbage');
            });
        } else {
            setTimeout(() => {
                this.el.nativeElement.setAttribute('autocomplete', 'off');
            });
        }
    }


}

